import { useState } from "react";
import { View, TouchableOpacity } from "react-native";
import { List } from "react-native-paper";
import Modal from "../Modal";
import TextInput from "../TextInput";

export type JobTitleType = {
  id: string;
  jobTitle: string;
  jobClassification?: string;
};

interface JobTitlePickerInputProps {
  jobTitlesData: JobTitleType[];
  onChange: (jobTitle: JobTitleType) => void;
  value: string;
  error?: { message?: string };
  placeholder?: string;
}

interface JobTitlePickerProps {
  jobTitlesData: JobTitleType[];
  visible: boolean;
  onChangeFn: (item: JobTitleType) => void;
  onDismiss(): void;
}

const ItemSeparatorComponent = () => <View className="border-b border-sky" />;

const renderItem =
  (onChange: (item: JobTitleType) => void) =>
  ({ item }: { item: JobTitleType }) => (
    <List.Item testID="jobTitleListItem" title={item.jobTitle} onPress={() => onChange(item)} />
  );

export function JobTitlePicker({ jobTitlesData, visible, onChangeFn, onDismiss }: JobTitlePickerProps) {
  return (
    <Modal
      fullScreen
      webStyle={{ height: "75vh" }}
      flatListProps={{
        ItemSeparatorComponent,
        renderItem: renderItem(onChangeFn),
        data: jobTitlesData,
        keyExtractor: (item) => item.id,
        contentContainerStyle: { paddingBottom: 20 },
      }}
      title="Select Job Title"
      visible={visible}
      onDismiss={onDismiss}
    />
  );
}

const JobTitlePickerInput = ({ onChange, value, placeholder, error, jobTitlesData }: JobTitlePickerInputProps) => {
  const [showModal, setShowModal] = useState(false);

  function hideModal() {
    setShowModal(false);
  }

  return (
    <TouchableOpacity activeOpacity={0.7} onPress={() => setShowModal(true)} testID="jobTitlePickerInput">
      <TextInput editable={false} pointerEvents="none" value={value} placeholder={placeholder} error={error} />

      <JobTitlePicker
        visible={showModal}
        onChangeFn={(item: JobTitleType) => {
          onChange(item);
          hideModal();
        }}
        onDismiss={hideModal}
        jobTitlesData={jobTitlesData}
      />
    </TouchableOpacity>
  );
};

export default JobTitlePickerInput;
